export default import.meta.ROLLUP_FILE_URL_EUevT9lx;